export default __webpack_public_path__ + "static/media/la.d7702465.svg";